module.exports = __webpack_public_path__ + "img/6.4fd389ca.png";